<template>
    <div style="margin:0 -12px;">
        <div class="wrap">
            <div class="container">
                <div class="" style="padding-top:10%;">
                    <br>
                    <br>
                    <div class="row">
                        <div class="col">
                            <div class="text-center" style="font-size:20px;color:#fff;">
                                おめでとうございます！<br>
                                マッチングが成立しました！
                            </div>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="row">
                        <div class="col">
                            <div style="position:absolute;left:50%;margin-left:-170px;height:130px;">
                                <img src="/images/gif/matching01.gif" class="" style="height: 120px;width:auto;">
                                <img :src="login_user.icon_url" class="" style="border-radius: 5px;width: 120px;">
                            </div>
                            <div style="position: absolute;right:50%;margin-right:-170px;height:130px;">
                                <img :src="user.icon_url" class="" style="border-radius: 5px;width: 120px;">
                                <img src="/images/gif/matching02.gif" class="" style="height: 120px;width:auto;">
                            </div>
                            <div style="position: absolute;margin-left: -30px;margin-top: 30px;left: 50%;z-index:999;">
                                <img src="/images/Group12839.png" class="" style="width: 60px;">
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-10">
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <div class="d-grid gap-2" style="padding: 0 5px;">
                                <button type="button" class="btn btn-skip-outline" style="font-size:18px; padding:12px 0;"
                                    :onclick="`window.location.href = '/user/message/${mid}';`">
                                    <i class="bi bi-chat"></i>&nbsp;メッセージへ</button>
                                <button type="button" class="btn btn-skip"
                                    style="font-size:18px; padding:12px 0;border-color:#fff;"
                                    onclick="window.location.href = '/good/list';">閉じる</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: [],
            login_user: [],
            mid: "",
            type: 0,
        };
    },
    methods: {
        async fetchUsers() {
            let response = await axios.get("/api/user/mini/show/" + this.$route.params['uid'])
                .then((response) => {
                    this.user = response.data.user;
                    this.login_user = response.data.login_user;

                    if (this.login_user.is_limited) {
                        this.type = 1
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.mid = this.$route.query.mid
                            this.fetchUsers();
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.mid = this.$route.query.mid
                this.fetchUsers();
            }
        }
        else {
            this.mid = this.$route.query.mid
            this.fetchUsers();
        }
    },
}
</script>

<style scoped>
.matching-icon-posison {
    position: fixed;
    top: 25%;
    left: 50%;
    margin-top: -20px;
    margin-left: -25px;
    background-color: #fff;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    padding: 10px 12px;
    font-size: 25px;
    color: #FF5247;
    z-index: 99999;
}
</style>
